type NotificationType = 'success' | 'error'

export class Notification {
  type: NotificationType
  text: string
  timestamp: number
  constructor(type: NotificationType, text: string) {
    this.type = type
    this.text = text
    this.timestamp = Date.now()
  }
}

export interface NotificationState {
  notifications: Array<Notification>
  limit: number
}
